export const MODULE_NAME = 'xen:macro';
export const EXTENSION_NAMESPACE = 'com.atlassian.ecosystem';
export const CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE = 'com.atlassian.confluence.macro.core';
export const CONNECT_ADDON_ACTION_SUBJECT = 'connectAddon';
export const EXTENSION_TYPE_BODIED = 'bodiedExtension';
export const EXTENSION_TYPE_MULTI_BODIED = 'multiBodiedExtension';
